<template>
  <div class="col-12 d-flex justify-content-center mt-4 mb-4">
    <ButtonRed :text="button.buttonTitle" @click="handleModal" />
  </div>
  <ModalForm
    :modal="modal"
    :successModalData="successModalData"
    :show="showModal"
    @handleModal="handleModal"
  />
</template>

<script setup>
import { ref } from 'vue';
import ButtonRed from './ButtonRed.vue';
import ModalForm from './modals/ModalForm.vue';

const props = defineProps({
  button: {
    buttonTitle: String,
  },
  modal: Object,
  successModalData: Object,
})

const showModal = ref(false);

const handleModal = () => showModal.value = !showModal.value;

</script>